import React from "react";
import DateTimeFormInput from "components/framework/forms/DateTimeFormInput";
import TextFormInput from "components/framework/forms/TextFormInput";
import { OrderDto } from "services/apis/types/order/OrderDto";
import { getUtcDate } from "services/util/DateUtil";
import CardSectionHeader from "../../framework/cards/CardSectionHeader";
import { OrderHandler } from "services/apis/types/port/OrderHandler";
import { Row, Col } from "reactstrap";
import { EnvironmentUtil } from "services/util/EnvironmentUtil";
import { getTranslation } from "translations/TranslationService";
import { useIntl } from "react-intl";

const isMixNetworkUrl = EnvironmentUtil.isMixNetwork

type Props = {
  order: OrderDto;
};

function parseUtcDate(value?: unknown): Date | null {
  if (!value || typeof value !== "string") return null;
  return new Date(value.endsWith("Z") ? value : value + "Z");
}

export default function HandlingOverview(props: Props) {
  const intl = useIntl();
  
   const displayedDueDateValue = props.order.requestedDueDate ?? props.order.desiredDueDate;
   const displayedDueDate = parseUtcDate(displayedDueDateValue);
   const focDate = parseUtcDate(props.order.focDate);
   const displayedFocDateValue = props.order.npacFocDate ?? props.order.focDate;
   const displayedFocDate = parseUtcDate(displayedFocDateValue);

  
    const shouldShowTooltip =
    displayedDueDate && focDate && displayedDueDate.getTime() !== focDate.getTime();
    
  return (
    <>
      <CardSectionHeader labelTranslationId="orders.orderDetails.orderDetailsCard.handlingOverview" />
      <Row>
        {!isMixNetworkUrl && <Col md={6} xl={3}>
          <TextFormInput
            labelTranslationId="orders.orderDetails.orderDetailsCard.handledBy"
            value={props.order.metadata.handledBy && OrderHandler[props.order.metadata.handledBy]}
          />
        </Col>}
        {!isMixNetworkUrl && <Col md={6} xl={3}>
          <TextFormInput
            labelTranslationId="orders.orderDetails.orderDetailsCard.assignedTo"
            // value={props.order.or newInport.projectId} //TODO add when it's returned by the API
          />
        </Col>}
        <Col md={6} xl={3}>
          <DateTimeFormInput
            disabled
            labelTranslationId="orders.orderDetails.orderDetailsCard.desiredDueDate"
            value={displayedDueDate  && getUtcDate(displayedDueDate )}
            labelTooltipText={shouldShowTooltip ? getTranslation(intl, "requestedNewDueDate.info.tooltip") : undefined}
          />
        </Col>
        {!isMixNetworkUrl &&
        <TextFormInput          
            labelTranslationId="orders.portIn.stepTwo.FullOrPartialPort"
            value={props.order.metadata.fullOrPartialPort}
          /> 
        }
        {/* {isMixNetworkUrl && <Col md={6} xl={3}>
          <DateTimeFormInput
            disabled
            labelTranslationId="orders.orderDetails.orderDetailsCard.activationDate"
            value={props.order.desiredDueDate && getUtcDate(props.order.desiredDueDate)}
          />
        </Col>} */}
        <Col md={6} xl={3}>
          <DateTimeFormInput
            disabled
            labelTranslationId="orders.orderDetails.orderDetailsCard.focDate"
            value={displayedFocDate && getUtcDate(displayedFocDate)}
          />
        </Col>
      </Row>
    </>
  );
}
